const obj2Fd = (obj = {}) => {
  const fd = new FormData()

  for (const key in obj) {
    const value = obj[key]
    fd.append(key, value)
  }

  return fd
}

export default obj2Fd
